import styled from 'styled-components';

const LoadingScreen = styled.div`
  margin: auto;
  text-align: center;
`;

export default LoadingScreen;
